import * as React from 'react';
import CourtReporting939importExportCore from './CourtReporting939ImportExportCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { UserRoleEnum } from '../../redux/UserSlice';




const CourtReporting939ImportExportA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <CourtReporting939importExportCore userRole={isAdminUser ? UserRoleEnum.Admin : UserRoleEnum.EntityUser} />
        </React.Fragment>
    );
}

export default CourtReporting939ImportExportA;